import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import { apiGet } from "./api";

export type InformavimoBudas = "PREVENCINIS" | "REAKTYVUS" | "ABU";

/**
 * Vieno neveikiančio ir vartotojui matomo išorinio serviso būsena.
 * Grąžinama viešo (be autentifikacijos) endpoint'o `/public/v1/servisu-bukle`.
 */
export interface ServisoBukle {
    kodas: string;
    pavadinimas: string;
    vartotojoTekstas: string;
    susietosFormos: string[];
    informavimoBudas: InformavimoBudas;
}

/**
 * Iškviečia viešą servisų būsenos endpoint'ą. REACT_APP_API_URL baigiasi `/api`,
 * todėl pilnas kelias tampa `/api/public/v1/servisu-bukle?lang=...`.
 */
export function fetchServisuBukle(lang: string): Promise<ServisoBukle[]> {
    return apiGet("/public/v1/servisu-bukle", { lang });
}

/**
 * Grąžina šiuo metu neveikiančių, vartotojui matomų servisų sąrašą.
 * Kalbos jautrus (persikrauna pakeitus kalbą) ir klaidoms atsparus — jei
 * užklausa nepavyksta, grąžina tuščią masyvą (niekada nemeta klaidos į UI).
 *
 * Naudojimo pavyzdys formos puslapyje PREVENCINIAM informavimui (blokuoti "Pateikti"):
 *   // const down = useServisuBukle();
 *   // const blokuota = down.some(s => s.informavimoBudas !== 'REAKTYVUS' && s.susietosFormos.includes('L03'));
 *   // // disable Pateikti kai blokuota
 */
export function useServisuBukle(): ServisoBukle[] {
    const { i18n } = useTranslation();
    const lang = i18n.language === "en" ? "en" : "lt";

    const { data } = useQuery(["servisuBukle", lang], () => fetchServisuBukle(lang), {
        retry: false,
        staleTime: 60000,
        // Klaidas tyliai ignoruojame — banneris/prisijungimas neturi lūžti.
        onError: () => undefined,
    });

    return data || [];
}
